export default {
    heading: "Archivo",
    body: "Archivo"
}